import React from "react";
import { useNavigate } from "react-router-dom";
import Services from "./services"; // your class component
import "./sidebar.css";
const ServicesWithRouter = () => {
  const navigate = useNavigate();
  return <Services navigate={navigate} />;
};

export default ServicesWithRouter;
